import { createI18n } from 'vue-i18n'
import en from './locales/en.json'
import no from './locales/no.json'

const i18n = createI18n({
  locale: localStorage.getItem('language') || 'en',
  fallbackLocale: 'en',
  messages: {
    en,
    no
  }
})

export default i18n
